module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAANlJREFUKFN90aFKhFEQxfHfgtHgAwgWg7AvYDD6AkafQEFBBMWiQSyKdZvBZBMMFqPBB1DYYDAoaDMaFAxy8LtwvezntHtn/nNmzgxMjjlM4QXfdcmgeqRgD/MY4wtDvOMEH6mtgTNc4LYRXcA+1gMVYK2Tv+kZMaqp2Q2wjC2stPM28BEOCpDZV7t5e0R+vwNk2cQfNyZQG3guO2xi9E/raVzhsgBx4RoPPdAMjuNUAdIhtu7grYGSO8c2Xus7JHHaLX6HTywhdzjEU3u40ngWi50Z93isFX8A+xElvwNY+8sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontierPage/change.png
// module id = /oMs
// module chunks = 0